import { sendTrackingEvent } from '../services/service.tracking';
import { state as offerState } from '../store/store.offer';
import { state as offerVehicleState } from '../store/store.offer-vehicle';
import { formatReplacementTypes, getVehicleData } from '../utils/utils.tracking';

export const trackAppointmentRequestClick = (dealerIndex) =>
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: 'button::request-appointment::dealer',
    eventNonInteractive: true,
    eventData: { ...getVehicleData(), dealer: { dealerIndex } },
  });

export const trackAppointmentRequestTopClick = () =>
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: 'button::request-appointment::top',
    eventNonInteractive: true,
    eventData: getVehicleData(),
  });

export const trackAppointmentRequestSubmit = () => {
  const vehicleData = getVehicleData();
  let eventData = { ico: { offerId: offerState.offerId }, ...vehicleData };

  const voi = {
    catalog: 'kbb',
    condition: formatReplacementTypes(offerVehicleState.replacementTypes),
    makeId: offerVehicleState.replacementMakeId,
    modelId: offerVehicleState.replacementModelId,
    year: `${offerVehicleState.replacementVehicleYearMin}-${offerVehicleState.replacementVehicleYearMax}`,
  };

  if (offerVehicleState.hasReplacement) {
    eventData = { ...eventData, ...{ voi } };
  }

  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'submit',
    eventResult: 'submit::ico::request-appointment',
    eventNonInteractive: true,
    eventData,
  });
};

export const trackPhoneClick = (dealer = {}) =>
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: 'text-link::phone',
    eventNonInteractive: false,
    eventData: { ...getVehicleData(), dealer },
  });

export const trackSiteClick = (dealer = {}) =>
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: 'text-link::sitelink',
    eventNonInteractive: false,
    eventData: { ...getVehicleData(), dealer },
  });

export const trackSeeMoreDealersClick = () =>
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: 'text-link::see_more_dealers',
    eventNonInteractive: false,
    eventData: getVehicleData(),
  });

export const trackMoreInfoClick = (dealerIndex) => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: 'text-link::more-info::map',
    eventNonInteractive: false,
    eventData: { ...getVehicleData(), dealer: { dealerIndex } },
  });
};

export const trackGetDirectionClick = (dealerIndex) => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: 'text-link::get-directions',
    eventNonInteractive: false,
    eventData: { ...getVehicleData(), dealer: { dealerIndex } },
  });
};

export const trackInventoryClick = (matchInventory: string, dealerIndex = 0) => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: `image::vdp::inventory-${matchInventory}`, // image::vdp::inventory-partial
    eventNonInteractive: false,
    eventData: { ...getVehicleData(), dealer: { dealerIndex } },
  });
};
